import React, {Component} from 'react';
import Octicon, {ChevronUp,ChevronDown} from '@githubprimer/octicons-react';
import $ from 'jquery';

class Category extends Component {
    constructor(props) {
        super(props);

        this.setCategory = this.setCategory.bind(this);
        this.toggleTab = this.toggleTab.bind(this);
    }

    setCategory(e) {
        e.preventDefault();
        if(typeof e.target.dataset.id !== 'undefined') {
            this.props.setCategory(e.target.dataset.id);
            this.props.changeRoute('list');
        }
    }

    toggleTab(e) {
        e.preventDefault();
        var $this = $(e.target).parent();
        if($this.hasClass('root-category')) {
            if($this.hasClass('active') === false) {
                $this.find('li').removeClass('active').show();
                $this.addClass('active');
                $this.siblings('li').removeClass('active');
                $this.siblings('li').find('ul').fadeOut(300);
                $this.children('ul').fadeIn(300);
                this.props.setRootCategory($(e.target).data('id'));
                this.props.setCategory(0);
            }
        }else{
            if($this.hasClass('active') === false) {
                $this.addClass('active');
                $this.children('ul').slideDown(500);
                $this.siblings('li').slideUp(500);
            }else {
                $this.children('ul').slideUp(200, 'linear');
                $this.removeClass('active');
                $this.siblings('li').slideDown(200);
            }
        }
    }

    componentDidMount() {
        var act = '';
        if($('.root-category.active').length) {
            act = $('.root-category.active');
        }else{
            act = $('.root-category').first();
        }
        act.siblings('li').removeClass('active');
        act.siblings('li').find('ul').fadeOut(300);
        act.children('ul').fadeIn(300);
    }


    render() {
        let c = '';
        let noLink;
        let link;
        if(this.props.first) {
            link = <span className="no-select" onClick={(event) => this.toggleTab(event)} data-id={this.props.category.id}>{this.props.category.title}</span>
            noLink = <span className="no-select" onClick={(event) => this.toggleTab(event)} data-id={this.props.category.id}>{this.props.category.title}</span>
            c = 'root-category';
            if(this.props.active === '1' || this.props.rootCategory === this.props.category.id) {
                 c += ' active';
            }
        }else{
            link = <a className="no-select" href='' data-id={this.props.category.id} onClick={(event) => this.setCategory(event)}>{this.props.category.title}</a>
            noLink = <a className="no-select" href='' onClick={(event) => this.toggleTab(event)}>
                {this.props.category.title}
                <Octicon icon={ChevronDown} className="up" />
                <Octicon icon={ChevronUp} className="down" />
                </a>
        }
        if(typeof this.props.category.categories !== 'undefined' && this.props.category.categories.length > 0) {
            return (
                <li key={this.props.category.id} className={c}>
                    {noLink}
                    <ul>
                        {this.props.category.categories.map(function(item,index){
                            return <Category category={item} key={item.id} setCategory={this.props.setCategory} changeRoute={this.props.changeRoute} />;
                        }.bind(this))}
                    </ul>
                </li>
            )
        }else{
            if(c === '') {
                c += 'linked-menu';
            }else{
                c += ' linked-menu';
            }

            return (
                <li key={this.props.category.id} className={c}>
                    {link}
                </li>
            )
        }
    }
}

export default Category;


// WEBPACK FOOTER //
// ./src/Components/Navigation/Category/Category.js